import { render, staticRenderFns } from "./ModalSaveProductLoader.vue?vue&type=template&id=e8e8eb00&scoped=true"
import script from "./ModalSaveProductLoader.vue?vue&type=script&lang=js"
export * from "./ModalSaveProductLoader.vue?vue&type=script&lang=js"
import style0 from "./ModalSaveProductLoader.vue?vue&type=style&index=0&id=e8e8eb00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e8eb00",
  null
  
)

export default component.exports